import React from "react";
import styled from "styled-components";
import { IonHeader, IonSegment } from "@ionic/react";
import { get } from "lodash";
import { CardCategory } from "./Item";
import { colors } from "../../helpers";
export const ListItem = ({ theme, data, currentCategory, setCurrentCategory }) => {
    return (React.createElement(Header, { translucent: true },
        React.createElement(WrapperIonSegment, { color: colors[get(theme, 'color.backgroundHeader')], scrollable: true, mode: "md", onIonChange: (props) => setCurrentCategory(props.detail.value) }, data.map((value) => (React.createElement(CardCategory, { key: value.id, theme: theme, currentCategory: currentCategory, id: value.id, name: value.name }))))));
};
const WrapperIonSegment = styled(IonSegment) `
  padding-left: 8px;
  background-color: ${props => props.color};
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  ::-webkit-scrollbar {
    display: none;
  }
`;
const Header = styled(IonHeader) `
  box-shadow: 0px 10px 10px -7px rgba(0,0,0,.15);
  & ::after {
    height: 0;
    display: none;
  }
`;
